export default __webpack_public_path__ + "static/media/NFTIntegration.23b0cec4.png";